export enum Monedas {
  CL = 'CLP',
  VE = 'VES',
  USDT = 'USDT'
}
